import { create } from "zustand";

interface WindowSizeState {
    width: number;
    height: number;
    resize: () => void;
}

export const useWindowSizeStore = create<WindowSizeState>()(set => ({
    width: window.innerWidth,
    height: window.innerHeight,
    resize: () => {
        window.addEventListener("resize", () =>
            set({
                width: window.innerWidth,
                height: window.innerHeight,
            })
        );
    },
}));

// registra una única vez este listener
useWindowSizeStore.getState().resize();
